import { InventoryBypassEndpoint } from '../common/endpoints';
import { getRequest, putRequest } from './requests';
import { ServerResponse, SettingList } from '../common/types';

export async function updateInventorySetting(payload: { slug: string, slugValue: boolean }) {
  const result: ServerResponse<null> = await putRequest(
    InventoryBypassEndpoint,
    payload,
  );
  return result;
}

export async function getInventorySettings(params: string) {
  const result: ServerResponse<SettingList> =
    await getRequest(`${InventoryBypassEndpoint}/?${params}`);
  return result;
}

export default {
  getInventorySettings
};